import React from 'react'
import moment from 'moment-timezone'
// @ts-ignore no types
import { Text } from '@adc/ui-adc'
import { usePropertyContext } from 'common/context/property'
import * as blueprint from '@adc/blueprint'
import { SAVE_PROPERTY_CTA_TPS } from '../../../statics'
import AuctionDetailsTemplate, {
  tpsAdditionalContent,
  whySaveLink,
  SavePropertyButton,
} from '../template'
import hasSimilarProperties from '../../../utils/hasSimilarProperties'
import {
  CombinedListingType,
  useListingContext,
} from '../../../context/listing'
import CalendarPopup from './calendar'
import { getERVRow } from './common'

const detailContent = (
  listing: CombinedListingType,
  isInTour: boolean,
  isRedesignEnabled: boolean | undefined
) => {
  const postponementNewAuctionStartDate = moment(
    listing.listing_configuration?.postponement_new_auction_start_date,
    'YYYY-MM-DD'
  )
  const postponementNewAuctionEndDate = moment(
    listing.listing_configuration?.postponement_new_auction_end_date,
    'YYYY-MM-DD'
  )

  const newAuctionDates = [
    postponementNewAuctionStartDate,
    postponementNewAuctionEndDate,
  ]
    .filter(date => date.isValid())
    .map(date => date.format('MMM DD'))

  const details = [
    newAuctionDates.length > 0
      ? {
          label: (
            <Text color='gray' data-elm-id='countdown_timer_label'>
              {`New Auction ${newAuctionDates.length > 1 ? 'Dates' : 'Date'}`}
            </Text>
          ),
          value: (
            <Text
              color='gray'
              weight='heavy'
              data-elm-id='countdown_timer_value'
            >
              {newAuctionDates.join(' - ')}
              <CalendarPopup isInTour={isInTour} />
            </Text>
          ),
        }
      : {
          label: (
            <Text color='gray' data-elm-id='auction_starts_label'>
              Awaiting New Auction date
            </Text>
          ),
        },
  ]

  const ervRow = getERVRow(listing, isRedesignEnabled)
  ervRow && details.unshift(ervRow)

  return details
}

interface PostponedProps {
  similarProperties: any[]
  isInTour: boolean
  isRedesignEnabled?: boolean
}

const Postponed = ({
  similarProperties,
  isInTour,
  isRedesignEnabled,
}: PostponedProps) => {
  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()

  const isSaved = property.is_currently_saved
  return (
    <AuctionDetailsTemplate
      title='Online Auction - Postponed'
      primaryButton={
        <SavePropertyButton
          listing={listing}
          property={property}
          isSaved={isSaved}
          actions={propertyActions}
          options={{
            text: SAVE_PROPERTY_CTA_TPS,
          }}
        />
      }
      secondaryButton={whySaveLink()}
      additionalContent={
        blueprint.listing.utils.isFclOnlineAuction(listing) &&
        tpsAdditionalContent(hasSimilarProperties(similarProperties))
      }
      detailContent={detailContent(listing, isInTour, isRedesignEnabled)}
    />
  )
}

export default Postponed
